<template>
  <li
    class="nav-item px-2 text"
    style="text-align: left"
    >
    <!-- Titulo sección -->
    <a href="#" class="nav-link" v-if="showServiciosLogisticosMenu">
      <i class="nav-icon fas fa-truck"></i>
      <p>Servicios Logísticos<i class="fas fa-angle-left right"></i></p>
    </a>

    <ul class="nav nav-treeview">
      <li class="nav-item" v-if="showAdministradorDeTarifas">
        <a href="#" class="nav-link">
          <i class="nav-icon fas fa-circle text-xs"></i>
          <p>Administrador de Tarifas<i class="fas fa-angle-left right"></i></p>
        </a>

        <ul class="nav nav-treeview">

          <!-- Proveedores Terrestres -->
          <li class="nav-item" v-if="showTarifasProveedoresTerrestres">
            <router-link class="nav-link" to="/tarifado/tarifas_proveedores_Terrestres">
              <i class="nav-icon far fa-circle text-xs "></i>
              <p> Tarifas Proveedores Terrestres</p>
            </router-link>
          </li>

          <!-- Proveedores Documentales -->
          <li class="nav-item" v-if="showTarifasProveedoresDocumentales">
            <router-link
              class="nav-link"
              to="/tarifado/tarifas_proveedores_Documentales"
            >
              <i class="nav-icon far fa-circle text-xs "></i>
              <p> Tarifas Proveedores Documentales</p>
            </router-link>
          </li>

          <!-- Proveedores Extra Costos -->
          <li class="nav-item" v-if="showTarifasProveedoresExtraCosto">
            <router-link class="nav-link" to="/tarifado/proveedores_extra_costos">
              <i class="nav-icon far fa-circle text-xs "></i>
              <p>Tarifas Proveedores Extra Costos</p>
            </router-link>
          </li>

          <!-- Clientes Terrestres -->
          <li class="nav-item" v-if="showTarifasClientesTerrestres">
            <router-link class="nav-link" to="/tarifado/clientes_Terrestres">
              <i class="nav-icon far fa-circle text-xs "></i>
              <p>Tarifas Clientes Terrestres</p>
            </router-link>
          </li>

          <!-- Clientes Documentales -->
          <li class="nav-item" v-if="showTarifasClientesDocumentales">
            <router-link class="nav-link" to="/tarifado/tarifas_clientes_Documentales">
              <i class="nav-icon far fa-circle text-xs "></i>
              <p>Tarifas Clientes Documentales</p>
            </router-link>
          </li>

          <!-- Clientes Extra Costos -->
          <li class="nav-item" v-if="showTarifasClientesExtraCostos">
            <router-link class="nav-link" to="/tarifado/clientes_extra_costos">
              <i class="nav-icon far fa-circle text-xs "></i>
              <p>Tarifas Clientes Extra Costos</p>
            </router-link>
          </li>
          
        </ul>

      </li>

      <!--
      <li class="nav-item">

        <a href="#" class="nav-link">
          <i class="nav-icon fas fa-circle text-xs"></i>
          <p>Liquidaciones Ext. Costos<i class="fas fa-angle-left right"></i></p>
        </a>

        <ul class="nav nav-treeview">
          
          <li class="nav-item">
            <router-link class="nav-link" to="/servicios_logisticos/liquidaciones_extra_costos/glosas">
              <i class="nav-icon far fa-circle text-xs "></i>
              <p>Glosas</p>
            </router-link>
          </li>
          
          
          <li class="nav-item">
            <router-link class="nav-link" to="/servicios_logisticos/liquidaciones_extra_costos/liquidaciones_preliminares">
              <i class="nav-icon far fa-circle text-xs "></i>
              <p>Liquidaciones Preliminares</p>
            </router-link>
          </li>

          
          <li class="nav-item">
            <router-link class="nav-link" to="/servicios_logisticos/liquidaciones_extra_costos/liquidaciones_finales">
              <i class="nav-icon far fa-circle text-xs "></i>
              <p>Liquidaciones Finales</p>
            </router-link>
          </li>
        </ul>

      </li>
      -->

    </ul>

    
  </li>
</template>

<script>


export default {
  data() {
    return {
      current_url: "",
      showServiciosLogisticosMenu         : false,
      showAdministradorDeTarifas          : false,
      showTarifasProveedoresTerrestres    : false,
      showTarifasProveedoresDocumentales  : false,
      showTarifasProveedoresExtraCosto    : false,
      showTarifasClientesTerrestres       : false,
      showTarifasClientesDocumentales     : false,
      showTarifasClientesExtraCostos      : false,
      showTarifaClienteExtraCosto         : false
    };
  },

  methods: {
    superAdmin(){
      this.showServiciosLogisticosMenu          = true;
      this.showAdministradorDeTarifas           = true;
      this.showTarifasProveedoresTerrestres     = true;
      this.showTarifasProveedoresDocumentales   = true;
      this.showTarifasProveedoresExtraCosto     = true;
      this.showTarifasClientesTerrestres        = true;
      this.showTarifasClientesDocumentales      = true;
      this.showTarifasClientesExtraCostos       = true;
      this.showTarifaClienteExtraCosto          = true;

    }
  },
  computed: {
    

  },
  created(){
    if(JSON.parse(localStorage.getItem('user'))?.rol === 'Super Administrador') this.superAdmin();
    const administracionRoleStructure = JSON.parse(localStorage.getItem('roleStructure')).find(({idModule}) => idModule === 9);
    
    if ( administracionRoleStructure ) {
      administracionRoleStructure.sections.map(({ idSection, subSections }) => {
        switch (idSection) {
          case 276: 
            this.showServiciosLogisticosMenu = true; 
            this.showAdministradorDeTarifas = true; 
            subSections.map(({ idSubsection }) => {
              switch (idSubsection) {
                case 270:
                  this.showTarifasProveedoresExtraCosto = true;
                  break;
                case 271:
                  this.showTarifasClientesExtraCostos = true;
                  break;
                case 272:
                  this.showTarifasProveedoresTerrestres = true;
                  break;
                case 273:
                  this.showTarifasProveedoresDocumentales = true; 
                  break;
                case 274:
                  this.showTarifasClientesTerrestres  = true;
                  break;
                case 275:
                  this.showTarifasClientesDocumentales  = true;
                  break;
              }
            });
        }
      });

    }

    const administracionUserStructure = JSON.parse(localStorage.getItem('userStructure')).find(({idModule}) => idModule === 9);
    if ( administracionUserStructure ) {
      administracionUserStructure.sections.map(({ idSection, subSections }) => {
        switch (idSection) {
          case 276: 
            this.showServiciosLogisticosMenu = true; 
            this.showAdministradorDeTarifas = true; 
            subSections.map(({ idSubsection }) => {
              switch (idSubsection) {
                case 270:
                  this.showTarifasProveedoresExtraCosto = true;
                  break;
                case 271:
                  this.showTarifasClientesExtraCostos = true;
                  break;
                case 272:
                  this.showTarifasProveedoresTerrestres = true;
                  break;
                case 273:
                  this.showTarifasProveedoresDocumentales = true; 
                  break;
                case 274:
                  this.showTarifasClientesTerrestres  = true;
                  break;
                case 275:
                  this.showTarifasClientesDocumentales  = true;
                  break;
              }
            });
        }
      });

    }


    // const user = JSON.parse(localStorage.getItem('user')) ;
    // user.id_role == 9999 && this.superAdmin() ;

    
  }
};
</script>
